

export class CloudConstants {
    static cloudInfraList = [
        {
            cloudProvider: 'Azure',
            image: './assets/img/partnerOnboarding/azure.png',
            region: 'Central US',
            description: 'Host your applications in Azure',
            value: 'azure',
            provider: 'apiplatform',
            selected: true,
            disabled: false
        },
        {
            cloudProvider: 'AWS',
            image: './assets/img/partnerOnboarding/aws-logo-square.png',
            region: 'US-East (N.Virginia)',
            description: 'Host your applications in AWS',
            value: 'aws',
            provider: 'apiplatform',
            selected: false,
            disabled: false
        },
        {
            cloudProvider: 'GCP',
            image: './assets/img/partnerOnboarding/gcp.png',
            region: 'US-East (N.Virginia)',
            description: 'Host your applications in GCP',
            value: 'gcp',
            provider: 'apiplatform',
            selected: false,
            disabled: false
        },
        // {
        //     cloudProvider: 'On Premise',
        //     image: './assets/img/partnerOnboarding/onPremises3.jpg',
        //     region: 'US-East (N.Virginia)',
        //     description: 'Host your applications on your premises',
        //     value: 'onpremise',
        //     provider: 'external',
        //     selected: false,
        //     disabled: true
        // }
    ];

    static externalCloudInfraList = [
        {
            cloudProvider: 'Azure',
            image: './assets/img/partnerOnboarding/azure.png',
            region: 'Central US',
            description: 'Host your applications in Azure',
            value: 'azure',
            provider: 'external',
            selected: false,
            disabled: false
        },
        {
            cloudProvider: 'AWS',
            image: './assets/img/partnerOnboarding/aws-logo-square.png',
            region: 'US-East (N.Virginia)',
            description: 'Host your applications in AWS',
            value: 'aws',
            provider: 'external',
            selected: false,
            disabled: false
        },
        {
            cloudProvider: 'GCP',
            image: './assets/img/partnerOnboarding/gcp.png',
            region: 'US-East (N.Virginia)',
            description: 'Host your applications in GCP',
            value: 'gcp',
            provider: 'external',
            selected: false,
            disabled: false
        },
    ];
}
